document.addEventListener("turbo:load", () => {
  console.log("Load: recaptach.js");

  const recaptcha_token = document.getElementById("recaptcha_token");
  if (!recaptcha_token){
    return;
  }

  const siteKeyMeta = document.querySelector('meta[name="recaptcha-site-key"]');
  if (!siteKeyMeta) {
    console.log("Recaptcha site key not found. Form is not protected.")
    return;
  }

  const siteKey = siteKeyMeta.content;

  document.querySelectorAll("form").forEach((form) => {
    if (form.dataset.recaptchaBound === "1") return;
    form.dataset.recaptchaBound = "1";

    const tokenInput = form.querySelector("#recaptcha_token");
    const actionInput = form.querySelector("#recaptcha_action");
    if (!tokenInput || !actionInput) return; // form doesn't use reCAPTCHA

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const action = actionInput.value || "form_submit";

      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(siteKey, { action }).then(function (token) {
          tokenInput.value = token;
          form.submit();
        });
      });
    });
  });
});